/* tslint:disable */
/* eslint-disable */
/**
 * FOPkasa.Web
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ReportByCurrentState } from '../models';
import { ReportByIncome } from '../models';
import { ReportByOperation } from '../models';
import { ReportByProduct } from '../models';
import { ReportByReceipt } from '../models';
import { ReportByReceiptAndProduct } from '../models';
import { ReportByReturnReceipt } from '../models';
import { ReportByWorkShift } from '../models';
/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pointOfSaleId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportCurrentStateGet: async (pointOfSaleId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/CurrentState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportIncomeGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/Income`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportOperationGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/Operation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportProductGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/Product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportReceiptAndProductGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/ReceiptAndProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportReceiptGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/Receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportReturnReceiptGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/ReturnReceipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportWorkShiftGet: async (startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Report/WorkShift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (startDateUtc !== undefined) {
                localVarQueryParameter['startDateUtc'] = (startDateUtc as any instanceof Date) ?
                    (startDateUtc as any).toISOString() :
                    startDateUtc;
            }

            if (endDateUtc !== undefined) {
                localVarQueryParameter['endDateUtc'] = (endDateUtc as any instanceof Date) ?
                    (endDateUtc as any).toISOString() :
                    endDateUtc;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            if (cashRegisterId !== undefined) {
                localVarQueryParameter['cashRegisterId'] = cashRegisterId;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pointOfSaleId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportCurrentStateGet(pointOfSaleId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByCurrentState>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportCurrentStateGet(pointOfSaleId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportIncomeGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByIncome>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportIncomeGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportOperationGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByOperation>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportOperationGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportProductGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByProduct>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportProductGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportReceiptAndProductGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByReceiptAndProduct>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportReceiptAndProductGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportReceiptGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByReceipt>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportReceiptGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportReturnReceiptGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByReturnReceipt>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportReturnReceiptGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportWorkShiftGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ReportByWorkShift>>>> {
            const localVarAxiosArgs = await ReportApiAxiosParamCreator(configuration).apiReportWorkShiftGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} [pointOfSaleId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportCurrentStateGet(pointOfSaleId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByCurrentState>>> {
            return ReportApiFp(configuration).apiReportCurrentStateGet(pointOfSaleId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportIncomeGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByIncome>>> {
            return ReportApiFp(configuration).apiReportIncomeGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportOperationGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByOperation>>> {
            return ReportApiFp(configuration).apiReportOperationGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportProductGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByProduct>>> {
            return ReportApiFp(configuration).apiReportProductGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportReceiptAndProductGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByReceiptAndProduct>>> {
            return ReportApiFp(configuration).apiReportReceiptAndProductGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportReceiptGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByReceipt>>> {
            return ReportApiFp(configuration).apiReportReceiptGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportReturnReceiptGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByReturnReceipt>>> {
            return ReportApiFp(configuration).apiReportReturnReceiptGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} [startDateUtc] 
         * @param {Date} [endDateUtc] 
         * @param {number} [pointOfSaleId] 
         * @param {number} [cashRegisterId] 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportWorkShiftGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ReportByWorkShift>>> {
            return ReportApiFp(configuration).apiReportWorkShiftGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @param {number} [pointOfSaleId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportCurrentStateGet(pointOfSaleId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByCurrentState>>> {
        return ReportApiFp(this.configuration).apiReportCurrentStateGet(pointOfSaleId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportIncomeGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByIncome>>> {
        return ReportApiFp(this.configuration).apiReportIncomeGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportOperationGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByOperation>>> {
        return ReportApiFp(this.configuration).apiReportOperationGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportProductGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByProduct>>> {
        return ReportApiFp(this.configuration).apiReportProductGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportReceiptAndProductGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByReceiptAndProduct>>> {
        return ReportApiFp(this.configuration).apiReportReceiptAndProductGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportReceiptGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByReceipt>>> {
        return ReportApiFp(this.configuration).apiReportReceiptGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportReturnReceiptGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByReturnReceipt>>> {
        return ReportApiFp(this.configuration).apiReportReturnReceiptGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Date} [startDateUtc] 
     * @param {Date} [endDateUtc] 
     * @param {number} [pointOfSaleId] 
     * @param {number} [cashRegisterId] 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public async apiReportWorkShiftGet(startDateUtc?: Date, endDateUtc?: Date, pointOfSaleId?: number, cashRegisterId?: number, partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ReportByWorkShift>>> {
        return ReportApiFp(this.configuration).apiReportWorkShiftGet(startDateUtc, endDateUtc, pointOfSaleId, cashRegisterId, partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
}
